import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceServiceTagForm from '../containers/ResourceServiceTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceServiceTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceServiceTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_service_tag_route_edit')} />
          <ResourceServiceTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceServiceTagEditScreen;

Logger.log('silly', `ResourceServiceTagEditScreen loaded.`);
